export default "__VITE_ASSET__CfXc0zLi__"